import React from "react";
import { MessageCircle } from "lucide-react";
import { CONTACT } from "../data/site";

export default function FloatingWhatsApp() {
  const href = `https://wa.me/${CONTACT.whatsappRaw}?text=${encodeURIComponent(
    "Hello Babul Corporation, I'd like to enquire about Indian FMCG exports."
  )}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-40 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366]/40 animate-ping" />
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-2xl hover:scale-110 transition-transform">
        <MessageCircle className="w-6 h-6" />
      </span>
      <span className="absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap px-3 py-1.5 rounded-full bg-navy text-white text-xs font-semibold opacity-0 group-hover:opacity-100 transition-opacity shadow-lg">
        Chat on WhatsApp
      </span>
    </a>
  );
}
